import { Col, Row } from "react-bootstrap";

const BarraNavegacion = () => {
  const links = [
    { href: "/desarrollo-web", label: "Desarrollo Web" },
    { href: "/app", label: "App" },
    { href: "/logo", label: "Logo" }
  ];
  return (
    <Col md={12} className="barra-navegacion">
      { links.map(({ href, label }) =>
        <Row key={href} className={window.location.pathname === href ? "enlace-elegido" : "enlace-no-elegido"}>
          <a href={href}>{label}</a>
        </Row>
      )}
    </Col>
  );
};

export default BarraNavegacion;
